import { useState } from 'react';

export default function useAuth(url) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const postData = async (body) => {
    setLoading(true);
    setError(null);
    setData(null);

    

    try {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include', // manda e riceve cookie (refresh token)
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      const json = await response.json();

      if (!response.ok) {
        const err = new Error(json?.detail || `Errore: ${response.status}`);
        err.responseData = json;
        err.status = response.status;
        throw err;
      }

      if (json.access) {
        sessionStorage.setItem('access_token', json.access); // salva access token
      }

      if (json.refresh) {
        sessionStorage.setItem('refresh_token', json.refresh);
      }

      setData(json);
      return { data: json, error: null };
    } catch (err) {
      setError(err);
      return { data: null, error: err };
    } finally {
      setLoading(false);
    }
  };

  const loginWithToken = ({ access, refresh = null }) => {
    try {
      if (access) {
        sessionStorage.setItem('access_token', access);
      }

      if (refresh) {
        sessionStorage.setItem('refresh_token', refresh);
      }

      setData({ access, refresh });
      setError(null);
      return { data: { access, refresh }, error: null };
    } catch (err) {
      setError(err);
      return { data: null, error: err };
    }
  };

  return { data, loading, error, postData, loginWithToken };
}
